import { render } from "./DeclareDuplicateCheck.vue?vue&type=template&id=64894ef6"
import script from "./DeclareDuplicateCheck.vue?vue&type=script&lang=js"
export * from "./DeclareDuplicateCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__